import { useEffect, useLayoutEffect } from 'react'

/** `useLayoutEffect` in the browser, `useEffect` on the server, where `useLayoutEffect` warns. */
export const useIsomorphicLayoutEffect: typeof useLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect
